itsoftApp.createModule("accordion", function () {
    var module = this;

    var initAccordions = function (accordion) {
        var accordionType = accordion.getAttribute("data-type");
        var accordionItems = accordion.querySelectorAll(".js-accordion-item");
        var accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");

        var onAccordionClick = function (evt) {
            var self = this;
            var selfPreventNone = self.hasAttribute("data-prevent-none");
            var selfOnce = self.hasAttribute("data-once");
            if (!selfPreventNone) {
                /* если специально не указан атрибут data-prevent-none, отменяем действие по умолчанию, например, переход по ссылке */
                evt.preventDefault();
            }
            var activeItem;
            var currentItem;

            // стили находятся в файле /assets/styles/page.styl

            var closeAccordion = function () { // el
                /* логика закрытия аккордеона */
                var accordionContent = activeItem.querySelector(".js-accordion-content");
                var accordionItem = activeItem;
                var closedText = accordionItem.getAttribute("data-closed-text");
                activeItem.classList.add("js-accordion-item--close-ready");

                var height = accordionContent.clientHeight + "px";
                accordionContent.style.height = height;

                if (closedText) {
                    activeItem.textContent = closedText;
                }

                var onTransitionEnd = function () {
                    accordionItem.classList.remove("js-accordion-item--active");
                    accordionItem.classList.remove("js-accordion-item--close-ready");
                    accordionContent.removeEventListener("transitionend", onTransitionEnd);
                };

                accordionContent.addEventListener("transitionend", onTransitionEnd);

                /* чтобы была анимация закрытия */
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        accordionContent.style.height = "0px";
                    });
                });
            };

            var openAccordion = function () { // el
                /* логика раскрытия аккордеона */
                var accordionContent = currentItem.querySelector(".js-accordion-content");
                var openedText = currentItem.getAttribute("data-opened-text");
                var accordionItem = currentItem;

                /* если есть атрибут со знаечением, заменяем название элемента аакордеона во время открытия */
                if (openedText) {
                    currentItem.textContent = openedText;
                }
                accordionItem.classList.add("js-accordion-item--open-ready");
                accordionContent.style.height = "auto";
                var height = accordionContent.clientHeight + "px";
                accordionContent.style.height = "0px";

                var onTransitionEnd = function () {
                    /* если одноврменно может быть показан только один элемент аккордеона, то добавляем другую анимацию,
                    чтобы раскрытый аккордеон не ушел за пределы экрана из-за прокрутки страницы */
                    // if (accordionType === "scroll") {
                    //     itsoftApp.modules.animateScroll.callback(accordionItem, null, 3000, null, "easeOutQuad");
                    // }
                    accordionItem.classList.remove("js-accordion-item--open-ready");
                    accordionItem.classList.add("js-accordion-item--active");
                    accordionContent.removeEventListener("transitionend", onTransitionEnd);
                };

                accordionContent.addEventListener("transitionend", onTransitionEnd);

                /* чтобы была анимация открытия */
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        accordionContent.style.height = height;
                    });
                });
            };

            /* если элемент аккордеона уже активен, скрываем его... */
            if (this.closest(".js-accordion-item--active")) {
                activeItem = this.closest(".js-accordion-item");
                closeAccordion();
                accordion.classList.remove("js-accordion--active");

            /* ...иначе показываем */
            } else {
                /* если одновременно может быть раскрыт только один элемент, то есть нет атрибута data-type со значением any... */
                if (accordionType !== "any") {
                    /*...находим ранее активный элемент и скрываем его */
                    activeItem = accordion.querySelector(".js-accordion .js-accordion-item--active");
                    if (activeItem) {
                        closeAccordion();
                    }
                }
                /* показываем элемент, по которому был осуществлён клик */
                currentItem = self.closest(".js-accordion-item");
                openAccordion();
                accordion.classList.add("js-accordion--active");
            }

            /* если есть атрибут data-once, то клик по элементу аккордеона отлавливается только один раз, то есть его нельзя закрыть */
            if (selfOnce) {
                self.removeEventListener("click", onAccordionClick);
            }
        };

        /* Добавляет каждому элементу аккордеона обработчик события клика */

        Array.prototype.forEach.call(accordionHeadElements, function (el) {
            el.addEventListener("click", onAccordionClick);
        });

        itsoftApp.modules.windowResize.addEvent(function () {
            if (accordion.classList.contains("js-accordion--active")) {
                Array.prototype.forEach.call(accordionItems, function (el) {
                    if (el.classList.contains("js-accordion-item--active")) {
                        var content = el.querySelector(".js-accordion-content");
                        content.style.height = "auto";
                        var height = content.clientHeight + "px";
                        content.style.height = height;
                    }
                });
            }
        });
    };

    /* Если с/до определённого разрешения аккордеона не должно быть, задаётся data-атрибут data-change-vw, значение которого должно быть ширина экрана, 1280, например */
    var changeableElements = document.querySelectorAll("[data-change-vw]");

    if (changeableElements) {
        /* Вычисляем текущую ширину вьюпорта */
        var currentViewport = itsoftApp.utils.getViewportSize();

        Array.prototype.forEach.call(changeableElements, function (changeableElement) {
            /* определяем - до или после этой ширины аккордеон должен быть инициализирован;
               атрибут data-change-direction принимает значение from или to */
            var direction = changeableElement.getAttribute("data-change-direction");

            /* если направление не указано, то по умолчанию будет from, то есть, начиная с разрешения экрана data-change-vw аккордеон будет работать */

            if ((direction === "from" || !direction ) && currentViewport >= +(changeableElement.getAttribute("data-change-vw"))) {
                var accordion = changeableElement.closest(".js-accordion");
                changeableElement.classList.add("js-accordion-item--active");
                accordion.classList.add("js-accordion--active");
            }
        });
    }

    module.callback = initAccordions;
});